import { Reducer } from "redux";
import { changeTheme } from "../../../components/administration/actions";
import { ThemeName } from "../../types";
import types from "../actionsIndex";

type State = ThemeName;
type Action =
  | ReturnType<typeof changeTheme>
  | { type: "OTHER_ACTION"; payload?: any };

const themeReducer: Reducer<any> = (
  previousState: State = "light",
  action: Action
) => {
  switch (action.type) {
    case types.settings.CHANGE_THEME:
      return action.payload;
    default:
      return previousState;
  }
};

export default themeReducer;
